module.exports = __webpack_public_path__ + "img/02@2x.fec9e807.png";